// Central site configuration — swap values here to update the whole site.

export const BUSINESS = {
  name: "NorthWork Cyprus",
  fullName: "NorthWork Cyprus — Air Conditioning",
  phoneDisplay: "+357 97 837 349",
  phoneTel: "+35797837349",
  whatsapp: "35797837349",
  whatsappUrl: "https://wa.me/35797837349",
  facebookUrl: "https://www.facebook.com/profile.php?id=61587147663725",
  website: "northworkcyprus.com",
  area: "Paphos, Cyprus",
};

// Append width/format params to Unsplash URLs for lighter, responsive delivery.
// Non-Unsplash sources (e.g. uploaded/local assets) are returned unchanged.
export const img = (url, w = 1400) =>
  url && url.includes("images.unsplash.com")
    ? `${url}&w=${w}&auto=format&fit=crop`
    : url;

export const IMAGES = {
  heroLiving:
    "https://images.unsplash.com/photo-1761330440311-16e160cad236?crop=entropy&cs=srgb&fm=jpg&q=85",
  splitUnit22:
    "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&q=85",
  livingWhite:
    "https://images.unsplash.com/photo-1784790601988-7915393bc5a1?crop=entropy&cs=srgb&fm=jpg&q=85",
  livingBlueArt:
    "https://images.unsplash.com/photo-1721045030396-a6af775ba1f7?crop=entropy&cs=srgb&fm=jpg&q=85",
  livingTV:
    "https://images.unsplash.com/photo-1716846135834-ae0490d08c83?crop=entropy&cs=srgb&fm=jpg&q=85",
  outdoorWall:
    "https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&q=85",
  outdoorSunny:
    "https://images.unsplash.com/photo-1758798157512-f0a864c696c9?crop=entropy&cs=srgb&fm=jpg&q=85",
  gaugeClose:
    "https://images.unsplash.com/photo-1694532438941-06bb0d95dae5?crop=entropy&cs=srgb&fm=jpg&q=85",
  gaugeMono:
    "https://images.unsplash.com/photo-1744302570296-d4bcb55b7002?crop=entropy&cs=srgb&fm=jpg&q=85",
  gaugeAnalog:
    "https://images.unsplash.com/photo-1563062067-6d3e3add387d?crop=entropy&cs=srgb&fm=jpg&q=85",
  roofWork:
    "https://images.unsplash.com/photo-1642749776312-aa42ce20c9f5?crop=entropy&cs=srgb&fm=jpg&q=85",
  acOutside:
    "https://images.unsplash.com/photo-1724488751821-1415f5cf4960?crop=entropy&cs=srgb&fm=jpg&q=85",
  technician:
    "https://images.unsplash.com/photo-1625148230889-8195e85aae6b?crop=entropy&cs=srgb&fm=jpg&q=85",
  indoorWall:
    "https://images.unsplash.com/photo-1759772238012-9d5ad59ae637?crop=entropy&cs=srgb&fm=jpg&q=85",
  pipework:
    "https://images.unsplash.com/photo-1694827893591-af9b80361599?crop=entropy&cs=srgb&fm=jpg&q=85",
  remote:
    "https://images.unsplash.com/photo-1730299789555-732cc7449039?crop=entropy&cs=srgb&fm=jpg&q=85",
  villaPool:
    "https://images.unsplash.com/photo-1765279162736-14c7d64ff820?crop=entropy&cs=srgb&fm=jpg&q=85",
  villaWhite:
    "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&q=85",
  cyprusVilla:
    "https://images.unsplash.com/photo-1622615822298-eb693dc257ce?crop=entropy&cs=srgb&fm=jpg&q=85",
  paphosCoast:
    "https://images.unsplash.com/photo-1759157261270-7c98d70fc36e?crop=entropy&cs=srgb&fm=jpg&q=85",
  paphosAerial:
    "https://images.unsplash.com/photo-1631087090375-930bb123be0a?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const SERVICES = [
  {
    key: "installation",
    title: "AC Installation",
    navLabel: "AC Installation",
    button: "Installation Services",
    path: "/ac-installation-paphos",
    icon: "Wrench",
    short:
      "Professional AC installation with careful positioning, clean pipework, drainage and finishing for a reliable completed installation.",
    image: "/images/installation-card.png",
    alt: "Wall-mounted split air conditioner with matching outdoor condenser unit and installation tools",
  },
  {
    key: "cleaning",
    title: "AC Deep Cleaning",
    navLabel: "AC Deep Cleaning",
    button: "Deep Cleaning",
    path: "/ac-deep-cleaning-paphos",
    icon: "Droplets",
    short:
      "Full internal cleaning with high-pressure washing and antibacterial treatment to remove built-up dirt and restore strong airflow.",
    image: "/images/cleaning-card.png",
    alt: "Indoor split air conditioner being deep cleaned with a high-pressure spray and drip collection bag",
  },
  {
    key: "repair",
    title: "AC Repair & Diagnostics",
    navLabel: "AC Repair & Diagnostics",
    button: "Repair & Diagnostics",
    path: "/ac-repair-paphos",
    icon: "Activity",
    short:
      "Professional inspection and troubleshooting for cooling problems, leaks, drainage faults, weak airflow, freezing, unusual noises and error codes.",
    image: "/images/repair-card.png",
    alt: "Technician using a multimeter to diagnose the circuit board of an open split air conditioner",
  },
  {
    key: "gas",
    title: "AC Gas Refill",
    navLabel: "AC Gas Refill",
    button: "Gas Refill Service",
    path: "/ac-gas-refill-paphos",
    icon: "Gauge",
    short:
      "System inspection and refrigerant-related service for air conditioners showing signs of low cooling performance or refrigerant loss.",
    image: "/images/gas-card.png",
    alt: "Outdoor condenser unit connected to manifold gauges and a refrigerant cylinder for a gas refill",
  },
];

// AC systems NorthWork supplies & installs. Prices are VAT-inclusive,
// supplied-and-installed (basic installation included).
export const PRODUCTS = [
  {
    id: "gree-pular",
    brand: "GREE",
    name: "GREE PULAR",
    image: "/images/gree-pular.webp",
    alt: "GREE PULAR wall-mounted inverter air conditioner with matching outdoor unit and remote control",
    blurb: "Energy-efficient inverter air conditioning with Wi-Fi smart control, quiet operation and reliable cooling and heating performance.",
    installLine: "GREE air conditioning supplied and professionally installed by NorthWork Cyprus.",
    features: [
      "A++ / A+++ Energy Efficiency",
      "Wi-Fi Smart Control",
      "Cooling & Heating",
      "Quiet Operation",
      "Modern Minimalist Design",
      "5-Year Warranty*",
    ],
    models: [
      { btu: "9,000 BTU", price: "€620" },
      { btu: "12,000 BTU", price: "€650" },
      { btu: "18,000 BTU", price: "€980" },
      { btu: "24,000 BTU", price: "€1,150" },
    ],
  },
  {
    id: "aux-q-series",
    brand: "AUX",
    name: "AUX Q Series",
    image: "/images/aux-q-series.webp",
    alt: "AUX Q Series wall-mounted inverter air conditioner with matching outdoor unit and remote control",
    blurb: "Reliable and energy-efficient inverter air conditioning supplied and professionally installed by NorthWork Cyprus.",
    installLine: "AUX air conditioning supplied and professionally installed by NorthWork Cyprus.",
    features: [
      "A++ / A+++ Energy Efficiency",
      "Wi-Fi Standard",
      "R32 Refrigerant",
      "Cooling & Heating",
      "5-Year Warranty*",
      "Basic Installation Included",
    ],
    models: [
      { btu: "9,000 BTU", price: "€580" },
      { btu: "12,000 BTU", price: "€620" },
      { btu: "18,000 BTU", price: "€900" },
      { btu: "24,000 BTU", price: "€1,100" },
    ],
  },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
